<template>
  <dara-single-content-layout container-size="lg">
    <template #content>
      <div class="d--flex justify-content--space-between align-items--center">
        <dara-header>{{ $t('questions') }}</dara-header>
        <dara-button @click="onCreateQuestion">
          {{ $t('add-question') }}
        </dara-button>
      </div>
      <table v-if="questionList && questionList.length > 0" class="table">
        <tbody>
          <tr v-for="question in questionList" :key="question.id">
            <td class="py-3 px-2">
              <dara-header size="sm" class="d-flex align-item--center">
                <dara-question-link :id="question.id">
                  {{ question.title }}
                </dara-question-link>
                <small v-if="question.answered">
                  <span
                    class="badge rounded-pill bg-light text-dark fw-light ml--lg color--success">
                    {{ $t('answered') }}
                  </span>
                </small>
              </dara-header>
              <dara-p color="regular">
                {{ question.content }}
              </dara-p>
            </td>
            <td class="align-middle text-end">
              <el-dropdown
                v-if="(!question.answered && canEdit(question)) || canDelete(question)"
                trigger="click">
                <dara-icon
                  icon="three-dots-vertical"
                  class="cursor--pointer mx--md" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="!question.answered && canEdit(question)">
                    <dara-question-link
                      :id="question.id"
                      action="edit">
                      <dara-icon size="sm" icon="pencil" />
                      {{ $t('edit') }}
                    </dara-question-link>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="canDelete(question)">
                    <a @click="setDeleteQuestion(question)">
                      <dara-icon size="sm" icon="trash" />
                      {{ $t('delete') }}
                    </a>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <dara-modal-delete
                v-if="showModal(question)"
                :content="$t('are-you-sure-you-want-to-delete-this-question')"
                @close="setDeleteQuestion(null)"
                @confirm="onDeleteQuestion(question)">
              </dara-modal-delete>
            </td>
          </tr>
        </tbody>
      </table>
      <dara-p v-else class="opacity--50 my--lg">( {{ $t('no-questions') }} )</dara-p>
      <dara-pagination
        :page.sync="pagination.page"
        :total="pagination.total"
        :page-size="pagination.limit"
        @current-change="fetch" />
    </template>
  </dara-single-content-layout>
</template>

<script>
import { toastError } from '@/services/toastService';
import { fetchQuestions, removeQuestion } from '@/modules/question/question.service';
import { goToCreateQuestion } from '@/modules/question/question.routes';
import { translate } from '@/services/translate.service';
import { getters } from '@/modules/user/user.store';

import DaraQuestionLink from '@/modules/question/components/QuestionLink.vue';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraMySpaceQuestions',
  components: {
    DaraQuestionLink,
    DaraSingleContentLayout,
  },
  data() {
    return {
      user: getters.getUser(),
      questionList: [],
      questionDelete: null,
      pagination: {
        page: 1,
        limit: 5,
      },
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.questionList = [];
      fetchQuestions(this.pagination)
        .then(data => {
          this.questionList = data.data;
          Object.assign(this.pagination, data.pagination);
        })
        .catch(() => {
          this.questionList = [];
        });
    },
    onCreateQuestion() {
      goToCreateQuestion(this.$router);
    },
    setDeleteQuestion(question) {
      this.questionDelete = question;
    },
    canEdit(question) {
      return question.user_id === this.user.id;
    },
    canDelete(question) {
      return question.user_id === this.user.id || this.user.permission > 1;
    },
    showModal(question) {
      return this.questionDelete && this.questionDelete.id === question.id;
    },
    onDeleteQuestion(question) {
      removeQuestion(question)
        .then(() => {
          this.$router.go(0);
        })
        .catch(() => toastError(`${translate('we-could-not-delete-your-question-at-this-moment')}`));
    },
  },
};
</script>
